import { c as y, p as b, y as w, x as A } from "./resize-bus-BJO1V4ET.js";
import { $mapPromise as P } from "./keys.es.js";
function M() {
  let o = !1;
  return (r) => {
    if (Array.isArray(r) || typeof r != "object")
      throw new Error("options should  be an object");
    if (typeof document > "u")
      return;
    const t = { ...r }, { libraries: p } = t;
    if (t.callback = "GoogleMapsCallback", Array.isArray(p) && (t.libraries = p.join(",")), o)
      window.console.info("You already started the loading of google maps");
    else {
      o = !0;
      const s = document.createElement("script");
      s.setAttribute("type", "text/javascript"), s.innerHTML = `
      ((g) => {
        var h,
          a,
          k,
          p = 'The Google Maps JavaScript API',
          c = 'google',
          l = 'importLibrary',
          q = '__ib__',
          m = document,
          b = window;
        b = b[c] || (b[c] = {});
        var d = b.maps || (b.maps = {}),
          r = new Set(),
          e = new URLSearchParams(),
          u = () =>
            h ||
            (h = new Promise(async (f, n) => {
              await (a = m.createElement('script'));
              e.set('libraries', [...r] + '');
              for (k in g)
                e.set(
                  k.replace(/[A-Z]/g, (t) => '_' + t[0].toLowerCase()),
                  g[k]
                );
              e.set('callback', c + '.maps.' + q);
              a.src = \`https://maps.\${c}apis.com/maps/api/js?\` + e;
              d[q] = f;
              a.onerror = () => (h = n(Error(p + ' could not load.')));
              a.nonce = m.querySelector('script[nonce]')?.nonce || '';
              m.head.append(a);
            }));
        d[l]
          ? console.warn(p + ' only loads once. Ignoring:', g)
          : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
      })(${JSON.stringify(t)});`, document.head.appendChild(s);
    }
  };
}
const k = M();
function j(o, r) {
  if (!o) throw new Error(r);
}
function C(o) {
  const {
    mappedProps: r,
    name: t,
    ctr: p,
    ctrArgs: s,
    events: h,
    beforeCreate: d,
    afterCreate: u,
    props: l = {},
    ...g
  } = o, m = `$${t}Promise`, n = `$${t}Object`;
  return j(!(l instanceof Array), "`props` should be an object, not Array"), {
    props: {
      ...l
    },
    setup() {
    },
    render() {
      return "";
    },
    provide() {
      const e = this, c = y(P).then((a) => {
        if (!a)
          throw new Error("the map instance is not defined");
        e.$map = a;
        const i = {
          map: a,
          ...b(l, e),
          ...e.options
        };
        if (d) {
          const f = d.bind(this)(i);
          if (f instanceof Promise)
            return f.then(() => ({ options: i }));
        }
        return { options: i };
      }).then(({ options: a }) => {
        const i = p();
        return e[n] = s ? (
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          new (Function.prototype.bind.call(
            i,
            null,
            ...s(
              a,
              b(l, e)
            )
          ))()
        ) : (
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          new i(a)
        ), w(
          r,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unnecessary-type-assertion
          e[n],
          e
        ), A(
          h,
          e[n],
          e
        ), u && u.bind(e)(
          e[n]
        ), e[n];
      });
      return e[m] = c, { [m]: c };
    },
    destroyed() {
      var c;
      const e = this;
      (c = e[n]) != null && c.setMap && e[n].setMap(null);
    },
    ...g
  };
}
export {
  k as g,
  C as p
};
